import PreparationService from '../../services/PreparationService';

export default {
    state: {
        collection: [],
    },
    getters: {
        getAllPreparations: store => store.collection,
    },
    mutations: {
        loadPreparations(state, payload) {
            state.collection = payload;
        },
    },
    actions: {
        async loadPreparations(context) {
            try {
                const payload = await PreparationService.getAll();
                context.commit('loadPreparations', payload);
                return payload;
            } catch (error) {
                throw Error(error.message);
            }
        },
    },
    namespaced: true,
};
